<template>
  <div id="signup">
    <div class="signup-form">
      <h2>Nuevo SubProjecto</h2>
      <form @submit.prevent="onSubmit">
        <v-select
          id="companyId"
          class="dropdown"
          v-model="companyId"
          :items="$store.state.companies"
          item-text="name"
          item-value="id"
          label="Company"
          @input="selectCompany(companyId)"
        />
        <!-- <div class="input">
          <label for="projectId">Project Id</label>
          <input id="projectId" v-model="projectId" type="text" />
        </div> -->
        <v-select
          v-show="projects"
          id="companyId"
          class="dropdown"
          v-model="projectId"
          :items="projects"
          item-text="name"
          item-value="id"
          label="Project"
        />
        <div class="input">
          <label for="name">Name</label>
          <input id="name" v-model="name" type="text" />
        </div>
        <div class="input">
          <label for="description">Description</label>
          <input id="description" v-model="description" type="text" />
        </div>
        <div class="submit">
          <button type="submit">Submit</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      description: "",
      country: "",
      projects: [],
      projectId: null,
    };
  },
  methods: {
    selectCompany(companyId) {
      // alert(companyId);
      this.projects = this.$store.state.companies.find(
        (x) => x.id === companyId
      ).projects;
    },
    onSubmit() {
      const formData = {
        name: this.name,
        description: this.description,
        projectId: this.projectId,
      };
      console.log(formData);
      this.$store.dispatch("addSubProject", formData);
      this.$router.push({
        name: "Admin",
      });
    },
  },
};
</script>

<style scoped>
.signup-form {
  width: 400px;
  margin: 30px auto;
  border: 1px solid #eee;
  padding: 20px;
  box-shadow: 0 2px 3px #ccc;
}

.input {
  margin: 10px auto;
}

.input label {
  display: block;
  color: #4e4e4e;
  margin-bottom: 6px;
}

.input.inline label {
  display: inline;
}

.input input {
  font: inherit;
  width: 100%;
  padding: 6px 12px;
  box-sizing: border-box;
  border: 1px solid #ccc;
}

.input.inline input {
  width: auto;
}

.input input:focus {
  outline: none;
  border: 1px solid #521751;
  background-color: #eee;
}

.input select {
  border: 1px solid #ccc;
  font: inherit;
}

.hobbies button {
  border: 1px solid #521751;
  background: #521751;
  color: white;
  padding: 6px;
  font: inherit;
  cursor: pointer;
}

.hobbies button:hover,
.hobbies button:active {
  background-color: #8d4288;
}

.hobbies input {
  width: 90%;
}

.submit button {
  border: 1px solid #521751;
  color: #521751;
  padding: 10px 20px;
  font: inherit;
  cursor: pointer;
}

.submit button:hover,
.submit button:active {
  background-color: #521751;
  color: white;
}

.submit button[disabled],
.submit button[disabled]:hover,
.submit button[disabled]:active {
  border: 1px solid #ccc;
  background-color: transparent;
  color: #ccc;
  cursor: not-allowed;
}
</style>
